import LoginForm from "../Components/forms/LoginForm";
import AuthShell from "../Components/auth/AuthShell";

export default function Login() {
    return <AuthShell title="Iniciar sesión" description="Entrá con contraseña o código para ver tus tickets.">
        <LoginForm />
    </AuthShell>;
}
